import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { urls } from "../../../../urls";
import { REQUEST_WIZARD_STEP_KEYS, type RequestStep } from "./requestWizardSteps";

export const useRequestStepNavigation = (eventId: string, requestId: string) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const rawStep = searchParams.get("step");
  const currentStep: RequestStep | null = REQUEST_WIZARD_STEP_KEYS.includes(rawStep as RequestStep)
    ? (rawStep as RequestStep)
    : null;

  useEffect(() => {
    if (!currentStep) {
      navigate(urls.portal.request.edit.go(eventId, requestId).intro);
    }
  }, [currentStep, eventId, requestId, navigate]);

  const navigateToStep = (step: RequestStep) => {
    navigate(urls.portal.request.edit.go(eventId, requestId)[step]);
    window.scrollTo(0, 0);
  };

  return { currentStep, navigateToStep };
};
